
export default {
    name: 'AccessEmailUpsell',
    methods: {
        goToPricing() {
            this.$store.commit('ui/hideModal');
            this.$router.push('/pricing/');
        },
    },
};
